import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiParams, ApiRequest } from './api.service';
import { JobService } from './job.service';

export interface CandidateAssociationParams extends ApiParams {
  assigned?: boolean;
  directApplicant?: boolean;
  'sort.direction'?: any;
  'sort.by'?: string;
}

@Injectable()
export class CandidateAssociationService extends JobService {
  constructor(http: HttpClient) {
    super(http);
    this.url = 'associations-for-candidate/';
  }

  get(request: Partial<ApiRequest<CandidateAssociationParams>> = {}): Observable<any> {
    const defaultParams: CandidateAssociationParams = {
      assigned: true,
      offset: 0,
      size: 10,
    };
    const params = {
      ...defaultParams,
      ...request.params,
    };
    return super.get({ ...request, params });
  }
}
